/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import { LuAsterisk } from 'react-icons/lu';

const TextInput = ({
    id = 'default-id',
    name = 'default-name',
    type = 'text',
    placeholder = 'Enter text',
    label = '',
    icon: Icon = null,
    inputClassName = '',
    iconClassName = '',
    containerClassName = '',
    labelClassName = '',
    autoComplete = 'off',
    errorMessage = '',
    autoFocus = false,
    required = false,
    value = '',
    otherContext = '',
    isDisabled = false,
    min = null,
    onChange = () => { },
    ...rest
}) => {
    const inputRef = useRef();

    useEffect(() => {
        if (autoFocus && inputRef.current) {
            inputRef.current.focus();
        }
    }, [autoFocus]);

    return (
        <div className={containerClassName}>
            {label && (
                <label
                    htmlFor={id}
                    className={`block text-sm font-medium mb-1 relative ${labelClassName}`}
                >
                    {label}
                    {required && (
                        <LuAsterisk className="inline text-red-500 ml-1" size={12} />
                    )}
                </label>
            )}

            {otherContext && (
                <p className="text-xs text-white/70 mb-1">{otherContext}</p>
            )}

            <div className="relative mt-1">
                {Icon && (
                    <Icon
                        className={`absolute left-3 top-2.5 text-gray-400 ${iconClassName}`}
                    />
                )}
                <input
                    id={id}
                    name={name}
                    type={type}
                    value={value}
                    onChange={onChange}
                    ref={inputRef}
                    autoComplete={autoComplete}
                    placeholder={placeholder}
                    disabled={isDisabled}
                    min={min}
                    className={`w-full px-4 py-4 rounded-md border text-sm focus:outline-none bg-transparent pl-${Icon ? '10' : '4'} ${errorMessage ? 'border-red-500' : 'border-black/10'
                        } ${inputClassName} ${isDisabled ? 'cursor-not-allowed' : ''}`}
                    {...rest}
                />
            </div>

            {errorMessage && (
                <p className="text-red-500 text-xs mt-1">{errorMessage}</p>
            )}
        </div>
    );
};

export default React.memo(TextInput);
